import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import Imgix, { Picture, Source } from "react-imgix";
import { ratioToCalc } from "../../utils";
import { Fragment } from "react";
import "lazysizes";
import "lazysizes/plugins/attrchange/ls.attrchange";
export var ImgixFit;
(function (ImgixFit) {
    ImgixFit["crop"] = "crop";
    ImgixFit["cover"] = "cover";
})(ImgixFit || (ImgixFit = {}));
export var ImgixAspectRatio;
(function (ImgixAspectRatio) {
    ImgixAspectRatio["ar3x4"] = "3:4";
    ImgixAspectRatio["ar4x3"] = "4:3";
    ImgixAspectRatio["ar16x9"] = "16:9";
    ImgixAspectRatio["ar21x9"] = "21:9";
    ImgixAspectRatio["ar1x1"] = "1:1";
    ImgixAspectRatio["ar_none"] = "none";
})(ImgixAspectRatio || (ImgixAspectRatio = {}));
export const ImgixImage = ({ imageUrl, imageAlt, imageMobileUrl = "", width, height, lazyload = true, sizes = "50vw", mobileSizes = "1000px", fit = ImgixFit.crop, aspectRatio = ImgixAspectRatio.ar3x4 }) => {
    const params = aspectRatio === ImgixAspectRatio.ar_none
        ? {
            fit: fit.toString(),
            ar: width && height ? `${width}:${height}` : "16:9",
            auto: "compress,format",
            cs: "tinysrgb"
        }
        : {
            ar: aspectRatio.toString(),
            fit: fit.toString(),
            auto: "compress,format",
            cs: "tinysrgb"
        };
    if (!imageUrl) {
        return null;
    }
    let lowQualityUrlFromImageUrl = imageUrl.split("?")[0];
    if (!lowQualityUrlFromImageUrl && lowQualityUrlFromImageUrl === undefined) {
        lowQualityUrlFromImageUrl = decodeURIComponent(imageUrl.replace(/\+/g, " "));
    }
    const lowQualWidth = 10;
    let lowQualHeight = 10;
    if (width && height) {
        const ratio = height / width;
        if (aspectRatio === ImgixAspectRatio.ar_none) {
            lowQualHeight = ratio * lowQualWidth;
        }
        else {
            lowQualHeight = lowQualWidth * ratioToCalc(aspectRatio);
        }
    }
    const imageSrc = `${lowQualityUrlFromImageUrl}?w=${lowQualWidth}&h=${lowQualHeight}&blur=20&auto=compress,format&fit=crop`;
    const attributeConfig = lazyload
        ? {
            src: "data-src",
            srcSet: "data-srcset",
            sizes: "data-sizes"
        }
        : {};
    const htmlAttributes = lazyload
        ? {
            src: imageSrc,
            alt: imageAlt
        }
        : { alt: imageAlt };
    const MobileImage = imageMobileUrl.length > 0 ? (_jsx(Source, { src: decodeURIComponent(imageMobileUrl.replace(/\+/g, " ")), sizes: mobileSizes, imgixParams: { auto: "compress,format", cs: "tinysrgb" }, htmlAttributes: { media: "(max-width: 500px)" }, className: lazyload ? "lazyload" : "", attributeConfig: attributeConfig })) : (_jsx(Fragment, {}));
    return (_jsxs(Picture, { children: [MobileImage, _jsx(Imgix, { src: decodeURIComponent(imageUrl.replace(/\+/g, " ")), imgixParams: params, sizes: sizes, className: lazyload ? "lazyload" : "", attributeConfig: attributeConfig, htmlAttributes: htmlAttributes, disableLibraryParam: true })] }));
};
//# sourceMappingURL=ImgixImage.js.map